import { jsx } from "react/jsx-runtime";
import { isVisibleOnWeb } from "../../../utils/contentstack/webApplicability.js";
import { getLinkBehavior } from "../../../utils/targetLinkBehavior/getLinkBehavior.js";
import { ListItem, List } from "@nxt-costco-com/forge-components";
import { SpaceSm, SpaceMd, SpaceXs } from "@nxt-costco-com/forge-design-tokens";
import { LinkListContainer } from "./LinkListContainer.js";
import { LinkListItem } from "./LinkListItem.js";
import { listStyles, ListWithGridDisplay } from "./styles.js";
function LinkListUI({
  containerSx,
  dataTestId = "",
  disablePopover,
  entry,
  insideFlyout = false,
  locale,
  maxLinksPerColumn,
  sx = listStyles,
  variant = "SimpleList",
  additionalComponentMap,
  ariaLabel,
  ariaDescribedBy,
  analyticsTitlePrefix
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  if (!isVisibleOnWeb(entry)) {
    return null;
  }
  if (!(entry == null ? void 0 : entry.link_list_style)) {
    console.error("LinkList error: Invalid entry.");
    return null;
  }
  if (!((_a = entry == null ? void 0 : entry.links_composer) == null ? void 0 : _a.length) && !additionalComponentMap) {
    return null;
  }
  if ((additionalComponentMap == null ? void 0 : additionalComponentMap.index) !== void 0 && (additionalComponentMap == null ? void 0 : additionalComponentMap.index) > ((_b = entry == null ? void 0 : entry.links_composer) == null ? void 0 : _b.length)) {
    return null;
  }
  const { target } = getLinkBehavior(
    (_c = entry == null ? void 0 : entry.listheader) == null ? void 0 : _c.external_site,
    (_d = entry == null ? void 0 : entry.listheader) == null ? void 0 : _d.same_tab_domain
  );
  if (entry.links_composer.length === 1) {
    const singleItem = /* @__PURE__ */ jsx(
      LinkListItem,
      {
        sx: {
          display: "block",
          padding: {
            lg: 0,
            md: `${SpaceXs}`,
            xs: `${SpaceSm} ${SpaceMd}`
          }
        },
        dataTestId,
        disablePopover,
        insideFlyout,
        link: entry.links_composer[0],
        linkListStyle: entry.link_list_style,
        locale
      },
      entry.uid
    );
    let containerChildren = [singleItem];
    if (additionalComponentMap) {
      containerChildren.splice(
        additionalComponentMap.index,
        0,
        additionalComponentMap.component
      );
      containerChildren = containerChildren.map((child, i) => {
        return /* @__PURE__ */ jsx(ListItem, { children: child }, i);
      });
    }
    return /* @__PURE__ */ jsx(
      LinkListContainer,
      {
        enableNavigation: entry.enable_navigation,
        entryId: entry.uid,
        navigationLabel: entry.navigation_label,
        sx: { marginBottom: SpaceMd, ...sx },
        title: (_e = entry.listheader) == null ? void 0 : _e.title,
        url: (_f = entry.listheader) == null ? void 0 : _f.url,
        variant,
        analyticsTitlePrefix,
        target,
        children: containerChildren
      }
    );
  }
  const childrenData = [...entry.links_composer];
  if (additionalComponentMap) {
    childrenData.splice(additionalComponentMap.index, 0, "Held Item");
  }
  const displayChildren = childrenData.map((link, i) => {
    if ((additionalComponentMap == null ? void 0 : additionalComponentMap.index) !== i) {
      return /* @__PURE__ */ jsx(ListItem, { children: /* @__PURE__ */ jsx(
        LinkListItem,
        {
          dataTestId,
          disablePopover,
          insideFlyout,
          link,
          linkListStyle: entry.link_list_style,
          locale
        }
      ) }, i);
    } else {
      return /* @__PURE__ */ jsx(ListItem, { children: additionalComponentMap.component }, i);
    }
  });
  if (maxLinksPerColumn && variant !== "Accordion") {
    return /* @__PURE__ */ jsx(
      LinkListContainer,
      {
        enableNavigation: entry.enable_navigation,
        entryId: entry.uid,
        navigationLabel: entry.navigation_label,
        title: (_g = entry.listheader) == null ? void 0 : _g.title,
        variant,
        analyticsTitlePrefix,
        target,
        children: /* @__PURE__ */ jsx(
          ListWithGridDisplay,
          {
            maxLinksPerColumn,
            variant,
            children: displayChildren
          }
        )
      }
    );
  }
  return /* @__PURE__ */ jsx(
    LinkListContainer,
    {
      ariaDescribedBy,
      ariaLabel,
      enableNavigation: entry.enable_navigation,
      entryId: entry.uid,
      navigationLabel: entry.navigation_label,
      sx: containerSx,
      title: (_h = entry.listheader) == null ? void 0 : _h.title,
      url: (_i = entry.listheader) == null ? void 0 : _i.url,
      variant,
      analyticsTitlePrefix,
      target,
      children: /* @__PURE__ */ jsx(
        List,
        {
          sx,
          variant: variant === "Accordion" ? "SimpleList" : variant,
          children: displayChildren
        }
      )
    }
  );
}
export {
  LinkListUI
};
